export default "__VITE_ASSET__D$lZtWTJ__"